import type { OwaTeamsPolicies } from "../store/schema";
import { getStore } from "../store/store";

export function isTeamsChatPolicyEnabled(): boolean {
    const policies = getStore().policies;
    
    return !!policies && teamsPolicyCheckImpl(policies);
}

export function teamsPolicyCheckImpl(policies: OwaTeamsPolicies): boolean {
    return policies.teamsUpgraded && policies.allowUserChat && policies.teamsFeatureEnabled;
}
